var _defs, _g, _polygon, _path, _path2, _path3, _polygon2, _path4, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeLengthWht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 325.23 198.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#eaeaea;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#1a1a1a;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -15.63,
    y1: 3.31,
    x2: 334.03,
    y2: 75.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#dddede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -26.05,
    y1: 53.79,
    x2: 323.6,
    y2: 126.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#dedfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 231.52,
    y1: 153.18,
    x2: -146.31,
    y2: 47.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.36 5.45 25.51 17.94 35.07 12.13 34.91 -0.35 25.36 5.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "34.99 -0.35 0 0 0.12 20.69 12.49 13.22 22.61 7.11 34.99 -0.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0.12 20.69 0.08 33.17 9.81 27.37 9.65 14.88 0.12 20.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "25.33 5.45 9.65 14.88 298.71 179.83 314.39 170.4 25.33 5.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.65 14.88 9.81 27.37 298.16 192.32 298.71 179.83 9.65 14.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "290.08 185.05 290.08 197.83 325.23 197.18 325.07 184.7 290.08 185.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "290.08 185.05 325.07 184.7 324.96 164.01 312.58 171.47 302.46 177.58 290.08 185.05"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "124.96 43.11 124.93 55.15 130.43 58.33 130.42 60.71 122.34 56.04 122.38 41.61 124.96 43.11"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M139,50.32a2.32,2.32,0,0,1-.86-.87,2.19,2.19,0,0,1-.32-1.07.72.72,0,0,1,.34-.7.88.88,0,0,1,.85.12,2.47,2.47,0,0,1,.85.85,2.06,2.06,0,0,1,.35,1.11.7.7,0,0,1-.34.69A.88.88,0,0,1,139,50.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.12,50.7l4.66,17.15L140,66.26l-.86-3.47-4.54-2.62-.87,2.47L131,61.05l4.71-11.73Zm-2.79,7.46L138.47,60l-1.56-6.31-1.58,4.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134,47.05a2,2,0,0,1-.34-1.1.72.72,0,0,1,.33-.71.89.89,0,0,1,.86.14,2.22,2.22,0,0,1,.86.86,2.17,2.17,0,0,1,.33,1.09.71.71,0,0,1-.33.69.88.88,0,0,1-.87-.13A2.33,2.33,0,0,1,134,47.05Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "154.21 59.99 154.16 74.42 151.58 72.93 146.57 60.52 146.54 70.02 143.96 68.53 144 54.09 146.58 55.59 151.6 68.02 151.63 58.5 154.21 59.99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.42,64a10,10,0,0,1,3.49,3.24,9.72,9.72,0,0,1,1.48,4.42l-2.52-1.45a5.17,5.17,0,0,0-.76-2.25,4.56,4.56,0,0,0-1.62-1.52c-.88-.51-1.55-.51-2,0a4.54,4.54,0,0,0-.72,3v.91a9,9,0,0,0,.75,3.87,5.29,5.29,0,0,0,2.19,2.43c1,.56,1.67.72,2.08.48V74.58l-2.36-1.37V71l4.94,2.85,0,5.76a2.42,2.42,0,0,1-2,.35,8.68,8.68,0,0,1-2.83-1.1,10.18,10.18,0,0,1-2.86-2.47A11.1,11.1,0,0,1,156.81,73a12.47,12.47,0,0,1-.67-4v-1a7.44,7.44,0,0,1,.64-3.38,2.39,2.39,0,0,1,1.84-1.37A4.68,4.68,0,0,1,161.42,64Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "176.9 73.09 176.89 75.5 171.08 72.15 171.07 75.58 176.04 78.45 176.03 80.76 171.06 77.89 171.05 81.78 176.88 85.15 176.88 87.53 168.46 82.67 168.5 68.24 176.9 73.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeLengthWht);
export default __webpack_public_path__ + "static/media/de-length-wht.4649a00b6b58da36df3114aa93fce218.svg";
export { ForwardRef as ReactComponent };